import { useExtensionRegistry } from "@core/components/PipelineComponents/ExtensionProvider";
import ExtensionPoint from "@core/components/PipelineComponents/ExtensionPoint";

interface ReplaceIfExtensionProps extends Record<string, any> {
  name: string;
}

export const ReplaceIfExtension = ({ children, name, ...props }: ReplaceIfExtensionProps) => {
  const { isRegistered } = useExtensionRegistry();
  
  return isRegistered(name) ? <ExtensionPoint name={name} {...props} /> : children;
};
